export default __webpack_public_path__ + "bdc68cf4ea8ec49926fa7e5400847594.woff2";